import { render, staticRenderFns } from "./ChartPais.vue?vue&type=template&id=9723f4cc&"
import script from "./ChartPais.vue?vue&type=script&lang=js&"
export * from "./ChartPais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports